import request from '@/plugins/request';
let Api = {};
const sys = '/user/'
const pre = 'menu_info';
// 列表
Api.tableList = function (data) {
    return request({
        url: `${sys}${pre}_page`,
        method: 'get',
        params: data
    });
}
// 查看
Api.getTableById = function (id) {
    return request({
        url: `${sys}${pre}_id/${id}`,
        method: 'get'
    });
}
// 新增
Api.addTable = function (data) {
    return request({
        url: `${sys}${pre}`,
        method: 'post',
        data
    });
}
// 编辑
Api.editTable = function (data) {
    return request({
        url: `${sys}${pre}`,
        method: 'patch',
        data
    });
}
// 删除
Api.deleteTable = function (id) {
    return request({
        url: `${sys}${pre}/${id}`,
        method: 'delete'
    });
}
// 批量删除
Api.deleteTableAll = function (ids) {
    return request({
        url: `${sys}${pre}_ids/${ids}`,
        method: 'delete'
    });
}
// 角色查菜单
Api.getMenusByRole = function (data) {
    return request({
        url: `${sys}${pre}/role_menus`,
        method: 'post',
        data
    });
}
// 菜单查功能权限
Api.getAuthByMenu = function (data) {
    return request({
        url: `${sys}${pre}/func_auth`,
        method: 'post',
        data
    });
}
// 生成模块Id
Api.generateModuleId = function (data) {
    return request({
        url: `${sys}${pre}/module_id`,
        method: 'post',
        data
    });
}
export default Api



// WEBPACK FOOTER //
// ./src/api/system/menu.js